export default __webpack_public_path__ + "static/media/Leicester.09e2a27b.svg";